import * as React from "react";

function ToggleTick() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="7.414" height="5.206" viewBox="0 0 7.414 5.206">
  <g id="Tick" transform="translate(-12550.531 8105.207)">
    <path id="Path_52982" data-name="Path 52982" d="M9921.082,13270.935l1.968,1.952,4.032-4" transform="translate(2630.156 -21373.387)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" strokeWidth="1"/>
  </g>
</svg>

  );
}

export default ToggleTick;